import { render, staticRenderFns } from "./BotaoTipoIcone.vue?vue&type=template&id=d5817240&scoped=true&"
import script from "./BotaoTipoIcone.vue?vue&type=script&lang=js&"
export * from "./BotaoTipoIcone.vue?vue&type=script&lang=js&"
import style0 from "./BotaoTipoIcone.vue?vue&type=style&index=0&id=d5817240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5817240",
  null
  
)

export default component.exports